import { AfterViewInit, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountSettingsDialogComponent } from 'src/app/_dialogs/account-settings-dialog/account-settings-dialog.component';
import { LocalStorageService, LoginService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';
declare const google: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {
    public auth2: any;
    public locale: string | null = '';

    constructor(
        public loginAPI: LoginService,
        private lStore: LocalStorageService,
        private dialog: MatDialog,
        private ssr: SsrlocalstoreService
    ) { }

    get loggedUser() {
        return this.lStore.getLocalStore().user.display_name ? this.lStore.getLocalStore().user.display_name : `${this.lStore.getLocalStore().user.first_name} ${this.lStore.getLocalStore().user.last_name}`
    }

    get loggedUserProfileImage() {
        return this.lStore.getLocalStore().user.profile_img ? this.lStore.getLocalStore().user.profile_img : '';
    }

    get loggedUserEmail(): string {
        return this.lStore.getLocalStore().user.email ? (this.lStore.getLocalStore().user.email as string) : '';
    }

    ngAfterViewInit(): void {
        this.locale = this.ssr.getItem('preferredLanguage')
        if (!this.locale) {
            this.locale = 'en'
        }
        this.initGoogleAuthSDK()
    }

    isLoggedIn() {
        return this.ssr.isLoggedIn()
    }

    initGoogleAuthSDK() {
        if (this.ssr.isClientSide) {
            setTimeout(() => {
                google.accounts.id.initialize({
                    client_id: environment.GOOGLE_CLIENT_ID,
                    scope: 'profile email',
                    callback: async (res: { clientId: string, credential: string, select_by: string }) => {
                        try {
                            await this.loginAPI.googleOAuth(res.credential);

                            if (this.ssr.isClientSide) {
                                window.location.reload();
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }
                });

                google.accounts.id.renderButton(
                    document.getElementById("loginButton"),
                    { theme: "outline", size: "medium", locale: this.locale, shape: 'pill' }
                );
            }, 250);
        }

    }

    openDialog() {
        const dialog = this.dialog.open(AccountSettingsDialogComponent, {
            data: { loggedUser: this.loggedUser, loggedUserProfileImage: this.loggedUserProfileImage, loggedUserEmail: this.loggedUserEmail },
            height: '400px',
            width: '100%',
            maxWidth: '450px'
        });

        dialog.afterClosed().subscribe(res => res && this.openDialog());
    }
}
